import { Insured } from './insured.model';
import { PaymentMethod } from './payment-method.model';
import { Policy } from './policy.model';
import { Producer } from './producer.model';
var DataStorage = /** @class */ (function () {
    function DataStorage() {
        this.branch = null;
        this.insured = new Insured();
        this.jobNumber = null;
        this.paymentMethod = new PaymentMethod();
        this.selectedPaymentTypeId = null;
        this.paymentMethods = [];
        this.groupId = null;
        this.policy = new Policy();
        this.policyPeriodId = null;
        this.producer = new Producer();
        this.risk = null;
    }
    return DataStorage;
}());
export { DataStorage };
